import type { ReactElement } from "react"
import PushOrg from "@onestore/hel/dist/components/organisms/PushOrg"
import Header from "@gatsby-plugin-generic-page/components/Header"
import type { Header as HeaderProps } from "@gatsby-plugin-generic-page/fragments/header"
import { Text } from "@ionos-web-design-system/react"
import UdsThemeProvider from "~/components/UdsThemeProvider"

const markdownUdsTitleOverrides = {
  h1: ({ children }) => (
    <Text
      variant="heading5xl"
      color="base"
      weight="bold"
      as="h1"
      alignment="center"
    >
      {children}
    </Text>
  ),
  h2: ({ children }) => (
    <Text
      variant="heading5xl"
      color="base"
      weight="bold"
      as="h2"
      alignment="center"
    >
      {children}
    </Text>
  ),
  h3: ({ children }) => (
    <Text
      variant="heading5xl"
      color="base"
      weight="bold"
      as="h3"
      alignment="center"
    >
      {children}
    </Text>
  ),
  p: ({ children }) => (
    <Text variant="heading5xl" color="base" weight="bold" alignment="center">
      {children}
    </Text>
  ),
}

const markdownUdsTextOverrides = {
  p: ({ children }) => (
    <Text variant="bodyXl" color="base" alignment="center">
      {children}
    </Text>
  ),
}

function SearchSectionUdsHeader(props: HeaderProps): ReactElement {
  return (
    <UdsThemeProvider>
      <PushOrg bottomSpace={4} hasNoReset>
        <Header
          {...props}
          titleOverrides={markdownUdsTitleOverrides}
          textOverrides={markdownUdsTextOverrides}
          textTopSpace={1}
        />
      </PushOrg>
    </UdsThemeProvider>
  )
}

export default SearchSectionUdsHeader
